export const TOPIC_STATUSES = 'TOPIC_STATUSES';


// WEBPACK FOOTER //
// ./src/store/modules/topicStatus/mutation-types.js